<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__crmchannelinfo}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="id" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:crmchannelinfo:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:crmchannelinfo:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <div class="tip_box">
        <h3>说明</h3>
        <p><span style="font-weight: bold;">渠道名字规范：</span>务必以,实时-，历史- 开始，同行数据渠道， 渠道以及落地页名称也要求一样</p>
        <p><span style="font-weight: bold;">注意：</span>如果新增渠道，在投放渠道表及落地页管理也新增同名渠道</p>
      </div>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <!-- <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column> -->
        <el-table-column prop="id" label="主键ID" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="channelName" label="渠道名称" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="number" label="编号" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="channelCode" label="渠道编码" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="balance" label="余额" header-align="center" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{'￥'+ Number(scope.row.balance).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}}
          </template>
        </el-table-column>
        <el-table-column prop="cost" label="花费" header-align="center" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{'￥'+ Number(scope.row.cost).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}}
          </template>
        </el-table-column>
        <el-table-column prop="type" label="类型" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="status" label="状态" header-align="center" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 1" size="small">启用</el-tag>
            <el-tag v-if="scope.row.status == 0" type="danger" size="small">禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sortOrder" label="排序" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="entryMethod" label="入库方式" header-align="center" align="center" width="120" >
          <template slot-scope="scope">
            <div>
              <el-tag size="small" style="margin: 4px 10px;" v-for="(item,index) in JSON.parse(scope.row.entryMethod)" :key="index">{{item}}</el-tag>
            </div>
            
          </template>
        </el-table-column>
        <el-table-column prop="script" label="话术" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="callbackSystem" label="回调系统" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="accessArea" label="准入区域" header-align="center" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-for="(item,index) in JSON.parse(scope.row.accessArea)" :key="index"><span v-if="index>0">,</span>{{item}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="appId" label="AppId" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="appSecret" label="AppSecret" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="releaseDate" label="上线时间" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="createDate" label="创建日期" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="updateTime" label="更新日期" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:crmchannelinfo:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:crmchannelinfo:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './crmchannelinfo-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/crmchannelinfo/page',
        getDataListIsPage: true,
        exportURL: '/sys/crmchannelinfo/export',
        deleteURL: '/sys/crmchannelinfo',
        deleteIsBatch: true
      },
      dataForm: {
        id: ''
      }
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
<style scoped lang="scss">
.tip_box{
  background-color: #f2f2f2;
  padding : 16px;
  margin-bottom: 30px;
  p{
    margin-left: 30px;
    line-height: 50px;

  }
}
</style>
